// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__zL2zm","copy":"footer_copy__nQca9"};